export const isTTSResponse = (payload) => {
    return typeof payload.audioContent === 'string';
};
